if (!customElements.get('pet-pillow-customizer')) {
  customElements.define('pet-pillow-customizer', class PetPillowCustomizer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.form = this.closest('form');
      this.nameInput = this.querySelector('[name="properties[Pet name]"]');
      this.photoInput = this.querySelector('[name="properties[Pet photo for pillow]"]');
      this.notesInput = this.querySelector('[name="properties[Pillow photo notes]"]');
      this.permissionInput = this.querySelector('[name="properties[Photo permission confirmed]"]');
      this.counter = this.querySelector('[data-pillow-count]');
      this.filename = this.querySelector('[data-pillow-filename]');
      if (!this.form || !this.nameInput || !this.photoInput || !this.notesInput || !this.permissionInput) return;
      this.allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
      this.maxBytes = 15 * 1024 * 1024;
      this.nameInput.addEventListener('input', () => this.clearError('name', this.nameInput));
      this.notesInput.addEventListener('input', () => { if (this.counter) this.counter.textContent = String(this.notesInput.value.length); });
      this.photoInput.addEventListener('change', () => { this.updatePhoto(); this.validatePhoto(false); });
      this.permissionInput.addEventListener('change', () => this.clearError('permission', this.permissionInput));
      this.form.addEventListener('submit', (event) => {
        if (!this.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }
    updatePhoto() {
      const file = this.photoInput.files && this.photoInput.files[0];
      if (this.filename) this.filename.textContent = file ? file.name : 'Choose photo';
      this.photoInput.closest('.pet-pillow-customizer__upload')?.classList.toggle('is-selected', Boolean(file));
    }
    clearError(key, input) {
      input.removeAttribute('aria-invalid');
      const error = this.querySelector('[data-pillow-error="' + key + '"]');
      if (error) error.textContent = '';
      input.closest('.pet-pillow-customizer__upload')?.classList.remove('is-invalid');
    }
    setError(key, input, message) {
      input.setAttribute('aria-invalid', 'true');
      const error = this.querySelector('[data-pillow-error="' + key + '"]');
      if (error) error.textContent = message;
      input.closest('.pet-pillow-customizer__upload')?.classList.add('is-invalid');
    }
    validatePhoto(required) {
      this.clearError('photo', this.photoInput);
      const file = this.photoInput.files && this.photoInput.files[0];
      if (!file) {
        if (required) this.setError('photo', this.photoInput, 'Upload one clear pet photo.');
        return !required;
      }
      if (!this.allowedTypes.includes(file.type)) {
        this.setError('photo', this.photoInput, 'Choose a JPG, PNG or WebP image.');
        this.photoInput.value = '';
        this.updatePhoto();
        return false;
      }
      if (file.size > this.maxBytes) {
        this.setError('photo', this.photoInput, 'Choose an image smaller than 15 MB.');
        this.photoInput.value = '';
        this.updatePhoto();
        return false;
      }
      return true;
    }
    validate() {
      let valid = true;
      this.clearError('name', this.nameInput);
      this.clearError('permission', this.permissionInput);
      if (!this.nameInput.value.trim()) {
        this.setError('name', this.nameInput, 'Enter your pet name.');
        valid = false;
      }
      if (!this.validatePhoto(true)) valid = false;
      if (!this.permissionInput.checked) {
        this.setError('permission', this.permissionInput, 'Confirm that you have permission to use the photo.');
        valid = false;
      }
      if (!valid) this.querySelector('[aria-invalid="true"]')?.focus();
      return valid;
    }
  });
}